export const questions = {
  "1. Oral Health Programs in the Community": [
    {
      id: 120001,
      question: "What is the first step in developing an oral health program?",
      options: [
        "Identify the target population",
        "Evaluate program outcomes",
        "Secure program funding",
        "Implement program activities"
      ],
      correctAnswer: 0
    },
    {
      id: 120002,
      question: "According to the material, what proportion of dental disease is found in 25% of citizens, guiding community targeting?",
      options: [
        "50% of dental disease",
        "80% of dental disease",
        "65% of dental disease",
        "95% of dental disease"
      ],
      correctAnswer: 1
    },
    {
      id: 120003,
      question: "Which groups are described as being at highest risk for poor oral health?",
      options: [
        "Middle-income working adults",
        "Teenagers in private schools",
        "Low-income children, those with special needs, and vulnerable elderly",
        "College students living on campus"
      ],
      correctAnswer: 2
    },
    {
      id: 120004,
      question: "What is typically the first step in planning a community oral health program?",
      options: [
        "Purchase dental equipment for the site",
        "Hire additional dental hygienists",
        "Publish results in a journal",
        "Contact the intended site to explain interest in the project"
      ],
      correctAnswer: 3
    },
    {
      id: 120005,
      question: "What are the four components necessary for initiating an oral health program?",
      options: [
        "Assessment, planning, implementation, and evaluation",
        "Funding, staffing, marketing, and reporting",
        "Screening, referral, treatment, and billing",
        "Survey, licensing, training, and closure"
      ],
      correctAnswer: 0
    },
    {
      id: 120006,
      question: "In the private practice parallel to community assessment, what corresponds to \"assessment\"?",
      options: [
        "Plan patient treatment",
        "Patient examination",
        "Treat the patient",
        "Evaluate patient treatment"
      ],
      correctAnswer: 1
    },
    {
      id: 120007,
      question: "How is \"assessment\" best defined in program planning?",
      options: [
        "A method of judging program merit after completion",
        "A budget plan for community outreach",
        "An organized, systematic approach to identify a target group and needs",
        "A tool for training program staff"
      ],
      correctAnswer: 2
    },
    {
      id: 120008,
      question: "How is \"planning\" defined in the program development process?",
      options: [
        "A summary of past program failures",
        "A method for recruiting volunteers only",
        "A record of completed treatments",
        "An organized response to reduce or eliminate one or more problems"
      ],
      correctAnswer: 3
    },
    {
      id: 120009,
      question: "What does \"implementation\" involve?",
      options: [
        "Putting the plan into action and monitoring activities and resources",
        "Reviewing legal constraints only",
        "Selecting the target population",
        "Writing the final evaluation report"
      ],
      correctAnswer: 0
    },
    {
      id: 120010,
      question: "What does \"evaluation\" measure?",
      options: [
        "The number of staff hired for the program",
        "Results of the program against objectives set in planning",
        "The cost of dental equipment",
        "The size of the target population only"
      ],
      correctAnswer: 1
    },
    {
      id: 120011,
      question: "What is \"formative evaluation\"?",
      options: [
        "A judgment made only after the program ends",
        "A survey of community members' opinions",
        "An internal examination of program processes as they occur",
        "A financial audit of program expenses"
      ],
      correctAnswer: 2
    },
    {
      id: 120012,
      question: "What is \"summative evaluation\"?",
      options: [
        "Identifying the target population before starting",
        "Training staff before implementation",
        "Assessing needs before planning begins",
        "Judging a program's merit after it has been operating"
      ],
      correctAnswer: 3
    },
    {
      id: 120013,
      question: "Which question is NOT listed as important when establishing health priorities?",
      options: [
        "The personal income of the program director",
        "The magnitude of the problem",
        "How many people are affected",
        "What resources are available"
      ],
      correctAnswer: 0
    },
    {
      id: 120014,
      question: "According to the material, what happens to dental needs when a community's basic needs for food and security are unmet?",
      options: [
        "Dental needs become the top priority",
        "Dental needs assume a low priority",
        "Dental needs are addressed before nutrition",
        "Dental needs are eliminated entirely"
      ],
      correctAnswer: 1
    },
    {
      id: 120015,
      question: "What balance must professionals strike when assessing community needs?",
      options: [
        "A balance between cost and profit",
        "A balance between speed and accuracy",
        "A balance between negligence and overzealousness",
        "A balance between staffing and equipment"
      ],
      correctAnswer: 2
    },
    {
      id: 120016,
      question: "Besides conducting a needs assessment, what other source can help identify community oral health problems?",
      options: [
        "Personal opinions of program directors",
        "National news reports",
        "Insurance company records",
        "Dental surveys done by other organizations"
      ],
      correctAnswer: 3
    },
    {
      id: 120017,
      question: "What is the purpose of \"goals\" in program planning?",
      options: [
        "To provide a broadly based statement of what changes will take place",
        "To provide precise cost estimates",
        "To list every staff member's duties",
        "To describe the exact measurement tools used"
      ],
      correctAnswer: 0
    },
    {
      id: 120018,
      question: "How do \"objectives\" differ from \"goals\"?",
      options: [
        "Objectives are broader and less specific than goals",
        "Objectives are more specific and describe measurable end results",
        "Objectives describe funding sources only",
        "Objectives replace the need for goals entirely"
      ],
      correctAnswer: 1
    },
    {
      id: 120019,
      question: "What is described as \"the key to a measurable objective\"?",
      options: [
        "The program budget",
        "The staff schedule",
        "The performance verb",
        "The community location"
      ],
      correctAnswer: 2
    },
    {
      id: 120020,
      question: "Besides the performance verb, what two elements make an objective more specific and useful?",
      options: [
        "A location and a date",
        "A budget and a timeline",
        "A staff list and a survey",
        "A condition and a criterion"
      ],
      correctAnswer: 3
    },
    {
      id: 120021,
      question: "When planning program activities, what must be carefully considered?",
      options: [
        "Available resources and program constraints",
        "Only the personal preferences of the director",
        "The weather forecast for the event",
        "The number of competing programs nearby"
      ],
      correctAnswer: 0
    },
    {
      id: 120022,
      question: "In the implementation strategy, what does the \"why\" question address?",
      options: [
        "The chronologic sequence of activities",
        "The effect of the objective to be achieved",
        "The cost estimate of materials and time",
        "The individuals responsible for each activity"
      ],
      correctAnswer: 1
    },
    {
      id: 120023,
      question: "In the implementation strategy, what does \"who\" refer to?",
      options: [
        "The materials and methods to be used",
        "The effect of the objective",
        "The individuals responsible for each activity",
        "The cost of the program"
      ],
      correctAnswer: 2
    },
    {
      id: 120024,
      question: "What is \"pilot testing\" in program implementation?",
      options: [
        "Evaluating a program after it has ended",
        "Surveying the entire target population at once",
        "Hiring a pilot to fly supplies to the site",
        "Using a smaller population with intent to expand later"
      ],
      correctAnswer: 3
    },
    {
      id: 120025,
      question: "What are the data obtained through measuring objectives called?",
      options: [
        "Measurable outcomes",
        "Community profiles",
        "Needs assessments",
        "Program constraints"
      ],
      correctAnswer: 0
    },
    {
      id: 120026,
      question: "What does a negative outcome in evaluation necessarily mean?",
      options: [
        "The program has completely failed",
        "It does not necessarily mean the program was a failure",
        "The program should be immediately shut down",
        "The evaluators made a serious error"
      ],
      correctAnswer: 1
    },
    {
      id: 120027,
      question: "How can formative evaluation influence the summative evaluation of a program with initial problems?",
      options: [
        "It always guarantees automatic program failure",
        "It has no effect on the final outcome",
        "Ongoing correction may lead to a successful summative evaluation",
        "It eliminates the need for any further evaluation"
      ],
      correctAnswer: 2
    },
    {
      id: 120028,
      question: "Program evaluation is described as an example of what type of research?",
      options: [
        "Basic research",
        "Clinical trial research",
        "Historical research",
        "Applied research"
      ],
      correctAnswer: 3
    },
    {
      id: 120029,
      question: "What is health education defined as in the material?",
      options: [
        "The process of teaching people about health",
        "The process of billing patients for treatment",
        "The process of licensing dental hygienists",
        "The process of designing dental clinics"
      ],
      correctAnswer: 0
    },
    {
      id: 120030,
      question: "Why has the cognitive model alone (attitude + knowledge = behavior change) been considered ineffective?",
      options: [
        "Because it requires too much funding",
        "Because participants must be actively involved in the learning process",
        "Because it only applies to adults",
        "Because it eliminates the need for evaluation"
      ],
      correctAnswer: 1
    },
    {
      id: 120031,
      question: "Which of the following is an example of an \"internal\" (individual) factor influencing dental education?",
      options: [
        "Cultural norms of the community",
        "Technology used to deliver information",
        "Beliefs, values, and perceptions of the individual",
        "Public policy affecting health programs"
      ],
      correctAnswer: 2
    },
    {
      id: 120032,
      question: "Which of the following is an example of an \"external\" (environmental) factor influencing dental education?",
      options: [
        "Personal income level",
        "Age of the individual",
        "Educational level of the individual",
        "Community influences, including cultural norms and public policy"
      ],
      correctAnswer: 3
    },
    {
      id: 120033,
      question: "What setting is described as continuing to be used for large-scale oral health education programs for children?",
      options: [
        "The school system",
        "Private dental offices only",
        "Online-only platforms",
        "Government tax offices"
      ],
      correctAnswer: 0
    },
    {
      id: 120034,
      question: "Which organizations are mentioned as additional avenues for oral health education outside of schools?",
      options: [
        "Stock exchanges and banks",
        "WIC, Head Start, Lions Clubs, and Rotary Clubs",
        "National sports leagues only",
        "Airlines and travel agencies"
      ],
      correctAnswer: 1
    },
    {
      id: 120035,
      question: "Which of the following is listed as a potential topic for oral health education programs?",
      options: [
        "Tax preparation for families",
        "Home renovation techniques",
        "Oral health effects of tobacco and oral cancer information",
        "Automobile maintenance tips"
      ],
      correctAnswer: 2
    },
    {
      id: 120036,
      question: "Community involvement and participation are described as essential during the planning process.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 120037,
      question: "A negative outcome in program evaluation always means the program was a total failure.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 120038,
      question: "Basic (clinical) research and applied research both emphasize the practical application of knowledge to develop solutions to problems.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 120039,
      question: "Dental surveys used for community needs assessment can be conducted by dental schools, local and state health departments, and community health centers.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    }
  ],
  "3. Population Health": [
    {
      id: 120040,
      question: "Which national survey is NOT listed among those monitoring oral health indicators in the United States?",
      options: [
        "NHANES",
        "American Community Survey (ACS)",
        "National Health Interview Survey (NHIS)",
        "Medical Expenditure Panel Survey (MEPS)"
      ],
      correctAnswer: 1
    },
    {
      id: 120041,
      question: "According to 2009-2010 NHANES data, what percentage of the adult sample aged 30 to 65+ had periodontitis?",
      options: [
        "28.5%",
        "62.9%",
        "35.7%",
        "47.2%"
      ],
      correctAnswer: 3
    },
    {
      id: 120042,
      question: "What trend has recent data since Healthy People 2020 shown regarding tooth loss?",
      options: [
        "A steady increase in both partial and complete tooth loss",
        "A possible increase in partial tooth loss alongside a continuing decrease in complete tooth loss",
        "A steady decrease in both partial and complete tooth loss",
        "No measurable change in either partial or complete tooth loss"
      ],
      correctAnswer: 1
    },
    {
      id: 120043,
      question: "The 2011 global summit on oral health resulted in which recommendation from the United Nations?",
      options: [
        "National initiatives should combine oral health promotion with disease-prevention schemes",
        "National initiatives should focus solely on treatment funding",
        "National initiatives should be run entirely by private dentists",
        "National initiatives should replace fluoridation with sealant programs"
      ],
      correctAnswer: 0
    },
    {
      id: 120044,
      question: "In 2012, which jurisdiction reported the highest percentage of residents with fluoridated water?",
      options: [
        "Hawaii (10.8%)",
        "Washington, D.C. (100%)",
        "California (75%)",
        "Texas (90%)"
      ],
      correctAnswer: 1
    },
    {
      id: 120045,
      question: "In 2009, which age group was more likely to report unmet dental healthcare needs in the past 12 months because of cost?",
      options: [
        "Children 6 to 12 years of age",
        "Adolescents 13 to 17 years of age",
        "Older adults 75 years and older",
        "Working-age adults 18 to 64 years of age"
      ],
      correctAnswer: 3
    },
    {
      id: 120046,
      question: "Approximately what percentage of adults aged 35 to 44 had untreated dental caries in 1999-2004?",
      options: [
        "28%",
        "12%",
        "45%",
        "60%"
      ],
      correctAnswer: 0
    },
    {
      id: 120047,
      question: "What term describes dental insurance coverage in the context of dental care financing?",
      options: [
        "Third-party payment",
        "Direct reimbursement model",
        "Capitation exchange",
        "Fee-forgiveness plan"
      ],
      correctAnswer: 0
    },
    {
      id: 120048,
      question: "What is the Healthy People 2020 target for the proportion of the U.S. population served by optimally fluoridated community water systems?",
      options: [
        "65.0%",
        "79.6%",
        "88.2%",
        "50.5%"
      ],
      correctAnswer: 1
    },
    {
      id: 120049,
      question: "Tooth decay is how many times more common than asthma among children?",
      options: [
        "Five times",
        "Two times",
        "Eight times",
        "Ten times"
      ],
      correctAnswer: 0
    },
    {
      id: 120050,
      question: "What is the projected 2025 workforce outcome for dental hygienists according to the chapter's workforce table?",
      options: [
        "A shortage of 15,600",
        "A surplus of 5,200",
        "A surplus of 28,100",
        "A shortage of 28,100"
      ],
      correctAnswer: 2
    },
    {
      id: 120051,
      question: "The most recent gingivitis data referenced in the chapter comes from which NHANES survey period?",
      options: [
        "1999-2004",
        "2005-2008",
        "1988-1994",
        "2009-2010"
      ],
      correctAnswer: 2
    },
    {
      id: 120052,
      question: "What percentage of persons aged 6 to 50 had sustained an injury resulting in damage to one or more anterior teeth?",
      options: [
        "10%",
        "40%",
        "25%",
        "55%"
      ],
      correctAnswer: 2
    },
    {
      id: 120053,
      question: "Which combination of risk factors represents a substantially greater risk for oral cancer than either substance alone?",
      options: [
        "Fluoride use combined with dental sealants",
        "Orthodontic treatment combined with mouthguard use",
        "Water fluoridation combined with dental insurance",
        "Tobacco use combined with excessive alcohol consumption"
      ],
      correctAnswer: 3
    },
    {
      id: 120054,
      question: "Between 2000 and 2005, how many people per 10,000 population were born annually with cleft lips and cleft palates?",
      options: [
        "4.50 per 10,000",
        "15.75 per 10,000",
        "10.20 per 10,000",
        "22.30 per 10,000"
      ],
      correctAnswer: 2
    },
    {
      id: 120055,
      question: "In 2010, what percentage of dental care expenditures in the U.S. were paid out-of-pocket, compared with 14.2% for overall health care?",
      options: [
        "25.0%",
        "60.3%",
        "47.5%",
        "80.7%"
      ],
      correctAnswer: 2
    },
    {
      id: 120056,
      question: "Which Canadian survey is used to collect national oral health data that is shared with global networks?",
      options: [
        "Canadian Oral Health Registry (COHR)",
        "National Dental Access Survey (NDAS)",
        "Canadian Community Health Index (CCHI)",
        "Canadian Health Measures Survey (CHMS)"
      ],
      correctAnswer: 3
    },
    {
      id: 120057,
      question: "The 5-year survival rate for oral and pharyngeal cancers increased from 52.6% in 1975 to what percentage in 2006?",
      options: [
        "64.7%",
        "58.3%",
        "70.1%",
        "80.4%"
      ],
      correctAnswer: 0
    },
    {
      id: 120058,
      question: "Which survey is used at the state and local level, integrated into the National Oral Health Surveillance System?",
      options: [
        "Global Oral Data Bank (GODB)",
        "Medical Expenditure Panel Survey (MEPS)",
        "Behavioral Risk Factor Surveillance Survey (BRFSS)",
        "National Immunization Survey (NIS)"
      ],
      correctAnswer: 2
    },
    {
      id: 120059,
      question: "Oral and pharyngeal cancers represent what percentage of all new cancer cases in the U.S.?",
      options: [
        "1.0%",
        "5.5%",
        "2.5%",
        "8.0%"
      ],
      correctAnswer: 2
    },
    {
      id: 120060,
      question: "What is the Healthy People 2020 target for the proportion of the population that used the oral healthcare system in the past year?",
      options: [
        "35%",
        "60%",
        "49%",
        "75%"
      ],
      correctAnswer: 2
    },
    {
      id: 120061,
      question: "In what year did the WHO begin building the Global Oral Data Bank (GODB)?",
      options: [
        "1975",
        "1969",
        "1982",
        "1990"
      ],
      correctAnswer: 1
    },
    {
      id: 120062,
      question: "How many dental school graduates were there in the United States in 2011?",
      options: [
        "3,100",
        "6,750",
        "2,400",
        "5,042"
      ],
      correctAnswer: 3
    },
    {
      id: 120063,
      question: "The CDC identified community water fluoridation as one of the great public health achievements of which century?",
      options: [
        "18th century",
        "20th century",
        "19th century",
        "21st century"
      ],
      correctAnswer: 1
    },
    {
      id: 120064,
      question: "What was the average annual expense for dental care per person in the United States in 2010?",
      options: [
        "$320",
        "$890",
        "$666",
        "$1,150"
      ],
      correctAnswer: 2
    },
    {
      id: 120065,
      question: "The public health infrastructure pyramid described in the chapter includes which of the following as its base level?",
      options: [
        "Direct health care services",
        "Infrastructure building services",
        "Population-based services",
        "Enabling services"
      ],
      correctAnswer: 1
    },
    {
      id: 120066,
      question: "Which of the following groups is listed as a vulnerable population that often lacks access to oral health care?",
      options: [
        "Migrant and seasonal farm workers",
        "Salaried full-time office employees",
        "Licensed dental hygienists",
        "Members of dental insurance boards"
      ],
      correctAnswer: 0
    },
    {
      id: 120067,
      question: "Teledentistry is best defined as which of the following?",
      options: [
        "A government program that funds free dental clinics",
        "The use of information technology and telecommunication for dental care, consultation, education, and public awareness",
        "A method of manufacturing dental sealants remotely",
        "A licensing exam for dental hygienists"
      ],
      correctAnswer: 1
    },
    {
      id: 120068,
      question: "What is the estimated lifetime cost of providing care to children born each year with cleft lip or cleft palate?",
      options: [
        "$150 million",
        "$1.2 billion",
        "$350 million",
        "$697 million"
      ],
      correctAnswer: 3
    },
    {
      id: 120069,
      question: "By what year had the percentage of the population served by fluoridated water reportedly reached 69%?",
      options: [
        "1992",
        "2000",
        "2006",
        "2012"
      ],
      correctAnswer: 2
    },
    {
      id: 120070,
      question: "According to a 2001 CDC study, how much is saved in dental treatment costs for every $1 invested in water fluoridation?",
      options: [
        "$38",
        "$12",
        "$55",
        "$100"
      ],
      correctAnswer: 0
    },
    {
      id: 120071,
      question: "Early childhood caries typically affects the primary teeth of children in which age range?",
      options: [
        "1 to 5 years of age",
        "Birth to 1 year of age",
        "6 to 9 years of age",
        "10 to 12 years of age"
      ],
      correctAnswer: 0
    },
    {
      id: 120072,
      question: "Which document described the oral health successes of the 20th century and helped shape future oral health directions?",
      options: [
        "A National Call to Action to Promote Oral Health",
        "Healthy People 2020 Framework",
        "The Global Oral Data Bank Report",
        "Oral Health in America: A Report of the Surgeon General"
      ],
      correctAnswer: 3
    },
    {
      id: 120073,
      question: "According to the national survey cited in the chapter, what percentage of persons aged 8 to 50 had severe crowding of the anterior incisors?",
      options: [
        "3%",
        "15%",
        "9%",
        "25%"
      ],
      correctAnswer: 2
    },
    {
      id: 120074,
      question: "What was the national average dentist-to-population ratio in 2013?",
      options: [
        "35.20 dentists per 100,000 people",
        "60.46 dentists per 100,000 people",
        "80.75 dentists per 100,000 people",
        "48.10 dentists per 100,000 people"
      ],
      correctAnswer: 1
    },
    {
      id: 120075,
      question: "What percentage of children aged 6 to 8 experienced dental caries in 1999-2004?",
      options: [
        "41%",
        "67%",
        "35%",
        "53%"
      ],
      correctAnswer: 3
    },
    {
      id: 120076,
      question: "What were the national dental care expenditures in the United States in 2012?",
      options: [
        "About $111 billion",
        "About $65 billion",
        "About $150 billion",
        "About $200 billion"
      ],
      correctAnswer: 0
    },
    {
      id: 120077,
      question: "According to the chapter, teledentistry as a subspecialty field can be traced to which 1994 initiative?",
      options: [
        "The WHO Global Teledentistry Initiative",
        "The Canadian Remote Dental Services Act",
        "The National Teledentistry Licensing Board",
        "The U.S. Army Total Dental Access Project"
      ],
      correctAnswer: 3
    },
    {
      id: 120078,
      question: "As of the data in this chapter, how many countries contribute oral health data to the Oral Health CAPP?",
      options: [
        "95 countries",
        "150 countries",
        "175 countries",
        "130 countries"
      ],
      correctAnswer: 3
    },
    {
      id: 120079,
      question: "The American Cancer Society estimated how many new oral and pharyngeal cancer cases would occur in 2015?",
      options: [
        "18,200",
        "62,750",
        "50,000",
        "39,500"
      ],
      correctAnswer: 3
    },
    {
      id: 120080,
      question: "Which national survey assesses the percentage of persons unable to get or delayed in getting needed dental care?",
      options: [
        "National Oral Data Bank (GODB)",
        "Medical Expenditure Panel Survey (MEPS)",
        "Canadian Health Measures Survey (CHMS)",
        "Behavioral Risk Factor Surveillance Survey (BRFSS)"
      ],
      correctAnswer: 1
    },
    {
      id: 120081,
      question: "Canada collaborates with which organization, along with the WHO Regional Office for the Americas, to improve oral health in the region?",
      options: [
        "Pan American Health Organization (PAHO)",
        "World Bank Health Division (WBHD)",
        "International Dental Federation (IDF)",
        "American Dental Cooperative (ADC)"
      ],
      correctAnswer: 0
    },
    {
      id: 120082,
      question: "According to the NHANES survey of 4- to 49-year-olds from 1999 to 2004, what percentage had no dental fluorosis?",
      options: [
        "60.6%",
        "45.2%",
        "72.9%",
        "33.4%"
      ],
      correctAnswer: 0
    },
    {
      id: 120083,
      question: "Which of the following is listed as a factor contributing to the burden of oral disease in Canada?",
      options: [
        "Limited oral health education and promotion efforts",
        "Excessive dental insurance coverage",
        "Overproduction of dental graduates",
        "Overuse of community water fluoridation"
      ],
      correctAnswer: 0
    },
    {
      id: 120084,
      question: "According to Box 5-2, which social impact of oral disease is specifically listed for adults?",
      options: [
        "Missing school",
        "Avoiding talking",
        "Losing work hours",
        "Delayed growth and development"
      ],
      correctAnswer: 2
    },
    {
      id: 120085,
      question: "What percentage of dentate older adults aged 65 and older had experienced dental caries in 1999-2004?",
      options: [
        "78%",
        "93%",
        "85%",
        "99%"
      ],
      correctAnswer: 1
    },
    {
      id: 120086,
      question: "According to NHANES 1999-2004, what percentage of people aged 75 years and older had root caries?",
      options: [
        "22%",
        "58%",
        "68%",
        "42%"
      ],
      correctAnswer: 3
    },
    {
      id: 120087,
      question: "Which preventive measure is described as effective on the pit and fissure surfaces of teeth but received by few children?",
      options: [
        "Fluoride varnish",
        "Orthodontic bands",
        "Mouth guards",
        "Dental sealants"
      ],
      correctAnswer: 3
    },
    {
      id: 120088,
      question: "The number of older adults in the U.S. is expected to increase from 43.1 million in 2012 to approximately how many by 2060?",
      options: [
        "65 million",
        "92 million",
        "110 million",
        "78 million"
      ],
      correctAnswer: 1
    },
    {
      id: 120089,
      question: "The WHO Oral Health Country/Area Profile Program (CAPP) was developed in what year?",
      options: [
        "1988",
        "2001",
        "1995",
        "2005"
      ],
      correctAnswer: 2
    },
    {
      id: 120090,
      question: "According to Box 5-2, which social impact of oral disease is specifically listed for children?",
      options: [
        "Avoiding smiling",
        "Losing work hours",
        "Suffering disfigurement",
        "Enduring work-family stress"
      ],
      correctAnswer: 0
    },
    {
      id: 120091,
      question: "What term is used to describe health insurance that uses techniques to control the cost of providing benefits?",
      options: [
        "Fee-for-service care",
        "Managed care",
        "Direct billing care",
        "Universal dental care"
      ],
      correctAnswer: 1
    },
    {
      id: 120092,
      question: "Community water fluoridation is considered one of the most equitable, cost-effective, and cost-saving methods of providing fluoride to a community.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 120093,
      question: "Oral cancer incidence has been declining in men since 1975 and in women since 1980, according to the chapter.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 120094,
      question: "The chapter states that periodontitis and gingivitis were both directly assessed by the 2009-2010 NHANES survey.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    },
    {
      id: 120095,
      question: "Dental premiums for private dental plans tend to be smaller than premiums for private health insurance plans.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 120096,
      question: "The chapter reports that the overall supply of dentists is projected to exceed demand in every U.S. state by 2025.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ],
  "2. Comprehensive Needs Assessment": [
    {
      id: 120097,
      question: "What is a \"need,\" according to the material?",
      options: [
        "The gap between what should be and what is",
        "The solution chosen to fix a problem",
        "The budget required for a program",
        "The list of activities already completed"
      ],
      correctAnswer: 0
    },
    {
      id: 120098,
      question: "Which equation correctly represents how a need is identified?",
      options: [
        "Desired result plus current result equals need",
        "Desired result minus current result equals need",
        "Current result minus desired result equals need",
        "Desired result divided by current result equals need"
      ],
      correctAnswer: 1
    },
    {
      id: 120099,
      question: "Which of the following is NOT listed as a way needs assessment supports better decisions?",
      options: [
        "Determines and describes important needs",
        "Examines the nature and causes of needs",
        "Guarantees unlimited funding for every need",
        "Sets priorities when resources are limited"
      ],
      correctAnswer: 2
    },
    {
      id: 120100,
      question: "In the \"ends vs. means\" approach, what should be assessed first?",
      options: [
        "The specific training method to be used",
        "The budget allocated to the activity",
        "The schedule for implementing the activity",
        "The outcome or result to be achieved"
      ],
      correctAnswer: 3
    },
    {
      id: 120101,
      question: "In the practical example, coaching and simulation are described as which type of element?",
      options: [
        "Means used to reach an outcome",
        "Outcomes to be measured directly",
        "System factors affecting scheduling",
        "Indicators used to prioritize needs"
      ],
      correctAnswer: 0
    },
    {
      id: 120102,
      question: "Which group is described as \"service providers\" in the needs assessment model?",
      options: [
        "Students or clients receiving services",
        "Faculty and support staff delivering services",
        "Policies governing the whole system",
        "External vendors supplying equipment"
      ],
      correctAnswer: 1
    },
    {
      id: 120103,
      question: "Besides service receivers and service providers, what else must be considered?",
      options: [
        "Marketing strategies for recruitment",
        "Historical enrollment trends",
        "System factors like policies and facilities",
        "Competitor program comparisons"
      ],
      correctAnswer: 2
    },
    {
      id: 120104,
      question: "What are the three phases of the needs assessment process, in order?",
      options: [
        "Make decisions, gather data, explore what is",
        "Gather data, make decisions, explore what is",
        "Analyze causes, explore outcomes, report findings",
        "Explore what is, gather and analyze data, make decisions"
      ],
      correctAnswer: 3
    },
    {
      id: 120105,
      question: "Which activity belongs to Phase I of the needs assessment process?",
      options: [
        "Preparing a management plan and setting preliminary priorities",
        "Writing the final action plan for implementation",
        "Analyzing causes of high-priority needs",
        "Preparing and communicating the final report"
      ],
      correctAnswer: 0
    },
    {
      id: 120106,
      question: "What is one required task in Step 1, preparing a management plan?",
      options: [
        "Quantify the discrepancy between outcomes",
        "Form a representative committee with clear roles",
        "Rank specific needs within each broad area",
        "Rate criticality of each need from 1 to 5"
      ],
      correctAnswer: 1
    },
    {
      id: 120107,
      question: "In Step 2, how many goals should the broad concerns be narrowed to?",
      options: [
        "One to two goals",
        "Six to eight goals",
        "Three to five goals",
        "Ten or more goals"
      ],
      correctAnswer: 2
    },
    {
      id: 120108,
      question: "In Steps 3-5, what does an \"indicator\" represent?",
      options: [
        "The location where evidence can be obtained",
        "The final decision about which need to fix",
        "The committee member assigned to a task",
        "The evidence that a concern actually exists"
      ],
      correctAnswer: 3
    },
    {
      id: 120109,
      question: "Which of the following is a step included in Phase II?",
      options: [
        "Gather data to define needs and identify causes",
        "Appoint a project lead for the committee",
        "Determine measurable indicators for concerns",
        "Evaluate and select improvement strategies"
      ],
      correctAnswer: 0
    },
    {
      id: 120110,
      question: "A complete need statement should include all of the following EXCEPT?",
      options: [
        "Identification of the target group",
        "A list of possible solutions to implement",
        "A statement of the desired outcome",
        "A statement of the current result"
      ],
      correctAnswer: 1
    },
    {
      id: 120111,
      question: "Interviews, focus groups, and open responses are examples of which data type?",
      options: [
        "Quantitative data",
        "Administrative data",
        "Qualitative data",
        "Observational data"
      ],
      correctAnswer: 2
    },
    {
      id: 120112,
      question: "According to the cause and consequence analysis, what should be done after listing the need?",
      options: [
        "Publish the final report immediately",
        "Assign a budget without further review",
        "Remove the need from consideration entirely",
        "Identify treatable causes and rate criticality"
      ],
      correctAnswer: 3
    },
    {
      id: 120113,
      question: "Which task is part of Phase III, turning evidence into action?",
      options: [
        "Propose an action plan and evaluate strategies",
        "Set preliminary priorities for further study",
        "Determine measurable indicators of concerns",
        "Determine target groups needing services"
      ],
      correctAnswer: 0
    },
    {
      id: 120114,
      question: "When choosing among possible solutions, which question should be asked?",
      options: [
        "Is it the least expensive option available?",
        "Is it acceptable to the people affected by it?",
        "Will it require the fewest meetings to plan?",
        "Was it used in a completely different program?"
      ],
      correctAnswer: 1
    },
    {
      id: 120115,
      question: "The final report should include the scope and methods, major findings, priority needs, the action plan, and recommendations for the next assessment cycle.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 0
    },
    {
      id: 120116,
      question: "According to the model, needs assessment is a one-time event and should not be repeated once the action plan is implemented.",
      options: [
        "True",
        "False"
      ],
      correctAnswer: 1
    }
  ]
};
